import { number } from 'echarts';

export const productEditMixin = {
    data() {
        const validate = (rule, value, callback) => {
            value.length ? (value = Number(value)) : '';
            if(isNaN(value)||!/^(\d|[1-9]\d|100)$/.test(value)){
                callback(new Error('请输入0-100之间的数字'));
            }
            if(value*1>100){
                callback(new Error('请输入0-100之间的数字'));
            }
            callback();
        };
        return {
            productForm: {
                id: '',
                productCode: '', //产品编码
                productName: '', //产品名称
                companyCode: '', //保险公司
                earliestRenewalDay: '', //最早续保日
                latestRenewalDay: '', //最晚续保日
                insureCost: '', //最低价
                hesitateTime: '', //犹豫期
                effectiveDay: '', //生效天数
                baseSalesNum: '', //基础销量
                commissionNum: '', //期数
                isGift: '0', //赠险
                titleLabel: [], //标签
                goodness: '', //产品卖点
                feature: '', //产品描述
                settlementDescription: '', //结算条件描述
                headImg: '', //手机详情头图
                detailImg: '', //手机详情图
                mobileCover: '', //手机端封面
                mobileBanner: '', //手机端banner
                source: '', // 产品来源
                insureUrl: '', // 投保链接
                isRenewal: '', // 是否可续保
                delayPeriod: '', // 最早续保日
                advancePeriod: '', // 最晚续保日
                regulatoryThemeId: [], //产品类别
                supplierType: '1',
                publishStatus: '1',
                insuranceType: '1',
                productMainType: '1',
                sellTypeOne: '1',
                sellType: [], // 产品类别，1网销，2电销，3经代产品；
                insureType: ['1'],// 投保方式 1自投，2代投，3纸质;
                canChangeIndex: '',
                salesStatus: '1',
                productType: '1',//保险分类
                isCollection: '0',
                isReceipt: '1',
                returnVisit: '1',//是否需要回访
                appointConsultUrl:"",
                supervise:'1',//监管报备
            },
            productFormRules: {
                publishStatus: [{ required: true, message: '请选择上架状态', trigger: 'change' }],
                salesStatus: [{ required: true, message: '请选择销售状态', trigger: 'change' }],
                isCollection: [{ required: true, message: '请选择是否代收保费', trigger: 'change' }],
                returnVisit: [{ required: true, message: '请选择是否需要回访', trigger: 'change' }],
                isReceipt: [{ required: true, message: '请选择是否需要回执', trigger: 'change' }],
                productMainType: [{ required: true, message: '请选择主附险类型', trigger: 'change' }],
                productCode: [{ required: true, message: '请输入产品编码', trigger: 'blur' }], //产品编码
                productName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }], //产品名称
                companyCode: [{ required: true, message: '请选择保险公司', trigger: 'change' }], //保险公司
                productType: [{ required: true, message: '请选择长短险标志', trigger: 'change' }], //保险分类
                earliestRenewalDay: [{ required: true, message: '请输入最早续保日', trigger: 'blur' }], //最早续保日
                latestRenewalDay: [{ required: true, message: '请输入最晚续保日', trigger: 'blur' }], //最晚续保日
                // insureCost: [{ required: true, message: '请输入最低价', trigger: 'blur' }], //最低价
                hesitateTime: [{ required: true, message: '请选择犹豫期', trigger: 'blur' }], //犹豫期
                commissionNum: [
                    { required: true, message: '请输入期数', trigger: 'blur', type: 'number' },
                    { validator: validate, trigger: 'blur', type: 'number' },
                ], //期数
                source: [{ required: true, message: '请输入产品来源', trigger: 'blur' }], //产品来源
                mobileCover: [{ required: true, message: '请上传手机端封面', trigger: 'change' }], //手机端封面
             },
            companyList: '',
            loading: true
        };
    },
    methods: {}
};
